<template>
    <div id="user_page" class="disconect_profile" v-if="page_loaded" :key="profile.id">
       
        <div class="centered_md">
          <form name="signupFRM" id="join_content" autocomplete="off" @submit.prevent="save()  ; unsubscribe()">   
<!-- ; unsubscribe()-->
            <div class="title" style="text-align:center;    font-size: 40px;font-weight: bold;"> עוד רגע וסיימנו..</div>
            <ul class="inputs_group">
              <li id="profile_input">
                <div class="icon proile_small"><div class="icon pencil"></div></div>
                
                <ul class="frmUL">
                      <li>
                <h3>
                רגע לפני שאנחנו מנתקים אתכם, נשמח אם תוכלו בכמה מילים לספר למה החלטתם לסיים את השירות..
                </h3>
              </li>
                    <li><span class="field"><input type="text"  placeholder="סיבת הניתוק:" required v-model="profile.reason"> </span></li>
                   <li> 
                       <label><b>באיזו מידה היית מרוצה ממגוון התכנים באתר?</b></label>
                    <label class="caption">בכלל לא <input type="radio"  placeholder=" 1"  v-model="profile.contents" value="1" required></label>
                  <label class="caption">במידה מועטה <input type="radio"  placeholder=" 2"  v-model="profile.contents" value="2"></label>
                   <label class="caption">במידה בינונית <input type="radio"  placeholder=" 3"  v-model="profile.contents" value="3"></label>
                    <label class="caption">במידה רבה <input type="radio"  placeholder=" 4"  v-model="profile.contents" value="4"></label>
                    <label class="caption">במידה רבה מאוד <input type="radio"  placeholder=" 5"  v-model="profile.contents" value="5"></label>

                    </li>
                     <li> 
                       <label><b>באיזו מידה היית מרוצה מאיכות התכנים? </b></label>
                    <label class="caption">בכלל לא <input type="radio"  placeholder=" 1"  v-model="profile.quality " value="1"></label>
                  <label class="caption">במידה מועטה <input type="radio"  placeholder=" 2"  v-model="profile.quality " value="2"></label>
                   <label class="caption">במידה בינונית <input type="radio"  placeholder=" 3"  v-model="profile.quality " value="3"></label>
                    <label class="caption">במידה רבה <input type="radio"  placeholder=" 4"  v-model="profile.quality " value="4"></label>
                    <label class="caption">במידה רבה מאוד <input type="radio"  placeholder=" 5"  v-model="profile.quality " value="5"></label>

                    </li>
                     <li> 
                       <label><b>באיזו מידה האתר היה נוח לשימוש? </b></label>
                    <label class="caption">בכלל לא <input type="radio"  placeholder=" 1"  v-model="profile.comfortable " value="1"></label>
                  <label class="caption">במידה מועטה <input type="radio"  placeholder=" 2"  v-model="profile.comfortable " value="2"></label>
                   <label class="caption">במידה בינונית <input type="radio"  placeholder=" 3"  v-model="profile.comfortable " value="3"></label>
                    <label class="caption">במידה רבה <input type="radio"  placeholder=" 4"  v-model="profile.comfortable " value="4"></label>
                    <label class="caption">במידה רבה מאוד <input type="radio"  placeholder=" 5"  v-model="profile.comfortable " value="5"></label>

                    </li>
                     <li >  
                       <label><b>באיזו מידה היית מרוצה מרמת הסינון בערוץ?</b></label>
                    <label class="caption">בכלל לא <input type="radio"  placeholder=" 1"  v-model="profile.restrictions " value="1"></label>
                  <label class="caption">במידה מועטה <input type="radio"  placeholder=" 2"  v-model="profile.restrictions " value="2"></label>
                   <label class="caption">במידה בינונית <input type="radio"  placeholder=" 3"  v-model="profile.restrictions " value="3"></label>
                    <label class="caption">במידה רבה <input type="radio"  placeholder=" 4"  v-model="profile.restrictions " value="4"></label>
                    <label class="caption">במידה רבה מאוד <input type="radio"  placeholder=" 5"  v-model="profile.restrictions " value="5"></label>

                    </li>
                </ul>
                <div class="hr"></div>
              </li>
            </ul>
            <input type="submit" value="המשך" class="btn"><br>
          </form>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      page_loaded: false,
      id: this.$route.params.id,
      profile: false,
      restrictions: [],
      saved_restrictions: [],
      insert_mode: false
    };
  },
  methods: {
      
    toggle_rest(id){
     
      var index = this.saved_restrictions.indexOf(id);

      if (index === -1) {
          this.saved_restrictions.push(id);
      } else {
          this.saved_restrictions.splice(index, 1);
      }

    },

    save(){
    
    this.api_call({ url: 'save_disconect', data: {
      insert_mode: this.insert_mode, 
      id: this.id, 
      reason: this.profile.reason, 
      contents: this.profile.contents, 
      quality : this.profile.quality , 
      restrictions : this.profile.restrictions , 
      comfortable : this.profile.comfortable , 
    }, onComplete: function(){

      document.location = '/user';

    } } );

    },
     unsubscribe(){
      var self = this;

      if (confirm('האם אתה בטוח שברצונך לבטל את המנוי?'))
      {
        this.api_call({ url: 'user/cancel_subscription', onComplete: function(){

          alert('המנוי בוטל');

          self.api_call({ url: 'general', onComplete: function(data){


            self.user = data.data.data.user;

          } } );

          //self.last_views = data.data.data.items;

        } } );
      }
    },


  },
  computed: {
    // a computed getter
    restrictions_list: function () {
    
        var restrictions = JSON.parse(JSON.stringify(this.$store.state.restrictions));
      
        for (let i in restrictions)
        {
            restrictions[i].is_active = (this.saved_restrictions.indexOf(restrictions[i].id) !== -1);
        }

        return restrictions;
      
    }
  },
  mounted() {

var self = this;
    if (this.id > 0)
    {
      // categories
      this.api_call({ url: 'get_profile', data: { id: this.id }, onComplete: function(data){
        
        data.data.data.perms_show_alerts = (data.data.data.perms_show_alerts == 1);
        data.data.data.perms_auto_skip = (data.data.data.perms_auto_skip == 1);
        data.data.data.perms_block_items = (data.data.data.perms_block_items == 1);

        self.profile = data.data.data;
        self.page_loaded = true;

        
        self.saved_restrictions = data.data.data.restrictions;

      } } );
    }
    else
    {
      this.insert_mode = true;
      this.page_loaded = true;
      this.profile = {
        name: '',
        age: '',
        restrictions: [],
        limit_hours: '', 
        password: ''

      };

    }
  }
}
</script>        